import "./index.scss";

export const IndexBalanceCheckLetter = ({ letter }) => {
  return (
    <a href={`#${letter}`} className="index-balance-check-letter">
      {letter}
    </a>
  );
};
